import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CmUiStandardButtonComponent, UiDialogComponent } from '@cm/ui-modules';

export interface SystemUpdateImageDialogData {
  src: string;
  title: string;
}

/** Lightbox for a system update's image — opened by `app-system-update-media`. */
@Component({
  selector: 'app-system-update-image-dialog',
  standalone: true,
  imports: [TranslatePipe, UiDialogComponent, CmUiStandardButtonComponent],   // no SHARED_IMPORTS — see system-update-body.component.ts
  templateUrl: './system-update-image-dialog.component.html',
  styleUrls: ['./system-update-image-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemUpdateImageDialogComponent {
  private readonly dialogRef = inject<DialogRef<void, SystemUpdateImageDialogComponent>>(DialogRef);
  protected readonly data = inject<SystemUpdateImageDialogData>(DIALOG_DATA);

  protected close(): void {
    this.dialogRef.close();
  }
}
